import { ChangeDetectorRef, Component, Inject, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'; 
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../services/admin.service';
import { messagelanguage } from 'src/environments/environment';
import { LocalCompany } from 'src/app/models/LocalCompany';
import { PatientService } from '../../patient/service/patient.service';
import { CountryCode } from 'libphonenumber-js';
import { LocationService } from 'src/app/services/location.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-createlocalcompany',
  templateUrl: './createlocalcompany.component.html',
  styleUrls: ['./createlocalcompany.component.scss']
})
export class CreatelocalcompanyComponent implements OnInit {
  oc_localCompany: LocalCompany = new LocalCompany();
  oc_listDistricts: any[]
  vc_isLoading: boolean;
  vc_idCompany:number;
  vc_idLocal:number;
  vc_textbtnGrabar:string = "Crear";
  vc_resources: any;
  vc_selectedCountryCode: CountryCode;
  vc_selectedLocations: { [key: number]: number } = {}; // Keyed by levelOrder
  private subscriptions: Subscription = new Subscription();

  constructor(public oc_dialogRef: MatDialogRef<CreatelocalcompanyComponent>,
    public oc_toastr: ToastrService, private oc_adminService: AdminService,
    private oc_locationService: LocationService,
    private oc_patientService: PatientService,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.vc_idCompany = data.idCompany; 
      this.vc_idLocal = data.idLocal;
    }

  async ngOnInit(): Promise<void> {
    this.fn_getResources();
  }

  async fn_getLocal() {
    if (this.vc_idLocal == -1) return;
    ((await this.oc_adminService.getDataLocal(this.vc_idCompany, this.vc_idLocal)).subscribe(
      async (res:any) => {
        this.vc_textbtnGrabar = "Actualizar";
        this.oc_localCompany = res.body;
        this.oc_localCompany.countryId = res.body.countryId.toString();
        if (this.vc_resources.selectedCountryId != this.oc_localCompany.countryId) {
          await this.fn_handleNewCountrySelection(this.oc_localCompany.countryId);
        }
        else {
          this.setDefaultLocationSelections(this.oc_localCompany.locationHierarchy);
        }
      },(error) => {
        console.error(error);
      }
    ))
      
  }

  async fn_getResources(countryId: string = null) {
    this.vc_isLoading = true;
    const resourcesPath = 'users/resources';
  
    try {
      this.subscriptions.add(
      (await this.oc_patientService.getResources(resourcesPath, countryId))
        .subscribe((resources: any[]) => {
          this.vc_resources = resources;
          this.vc_isLoading = false;
          this.fn_getLocal();
        }));
    } catch (error) {
      console.error(error);
      this.vc_isLoading = false;
      if (error.status === 500) {
        this.oc_toastr.error(
          messagelanguage.message.No_control_error + ' : ' + error.error.message
        );
      }
    }
  }



  // async ngAfterViewInit(): Promise<void> {
  //   this.cdr.detectChanges();
  // }
   
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // fn_getResources() {
  //   this.subscriptions.add(
  //     this.oc_patientService.resources.subscribe(
  //       async (o) => {
  //         console.log('Resources observable emitted:', o); // Check if it emits anything
  //         this.vc_resources = o;
  //         console.log('vc_resources:', this.vc_resources);
  //         if (this.vc_resources.selectedCountryId != this.oc_localCompany.countryId) {
  //           await this.fn_handleNewCountrySelection(this.oc_localCompany.countryId);
  //         }
  //         else {
  //           this.setDefaultLocationSelections(this.oc_localCompany.locationHierarchy);
  //         }
  //       },
  //       (error) => {
  //         console.error('Error in resources observable:', error);
  //       }
  //     )
  //   )
  // }

  fn_cancel() {
    this.oc_dialogRef.close({
      accept: false,
    });
  }

  fn_updatedPhoneNumber(phoneNumber): void{
    this.oc_localCompany.phone = phoneNumber;
  }

  fn_updateNormalizedPhoneNumber(phoneNumber) {
    this.oc_localCompany.normalizedPhone = phoneNumber
  }

  async fn_getLocations(countryId: string) { 
    if (countryId === '0') return; 
    (await this.oc_locationService.getAllLocationsForCountry(countryId))
      .subscribe(
        (response:any) => {
          this.vc_resources.locationLevels = response.body.locationLevels;
          this.vc_resources.locations = response.body.locations;
          this.vc_resources.selectedCountryId = response.body.selectedCountryId;
          if (this.oc_localCompany.locationHierarchy) {
            this.setDefaultLocationSelections(this.oc_localCompany.locationHierarchy);
          }
        }, error => {
          console.error(error);
        }
      )
  }

  fn_getCountryCode(countryId): CountryCode {
    let selectedCountryCode: CountryCode = "PE"
    switch (countryId) {
      case "2":
        selectedCountryCode = "ES"
        break;
      default:
        selectedCountryCode = "PE"
        break;
    }
    return selectedCountryCode
  }

  filterLocations(levelOrder: number): any[] {
    const locations = this.vc_resources?.locations?.[levelOrder] || [];
    const parentId = this.vc_selectedLocations[levelOrder - 1];
    const filteredLocations = locations.filter(loc => !loc.parentId || loc.parentId === parentId);

    return filteredLocations
  }


  async fn_handleNewCountrySelection(countryId: string) {
    this.vc_selectedLocations = {};
    this.vc_selectedCountryCode = this.fn_getCountryCode(countryId);  
    // Fetch location levels for the selected country
    await this.fn_getLocations(countryId);
  }

  setDefaultLocationSelections(patientLocationHierarchy: any[]) {
    if (!patientLocationHierarchy || !this.vc_resources.locations) {
      console.log('Missing hierarchy or locations, returning early.');
      return;
    }
  
    this.vc_selectedLocations = {};
  
    for (const hierarchyItem of patientLocationHierarchy) {
      const { levelOrder, id } = hierarchyItem;
      
      try {
        this.fn_handleSelectedLocation(id, levelOrder);
      } catch (error) {
        console.error(`Error processing hierarchyItem with LevelOrder: ${levelOrder}, Id: ${id}`, error);
      }
    }
  }

  fn_handleSelectedLocation(locationId: number, levelOrder: number) {
    try {
      this.vc_selectedLocations[levelOrder] = locationId;
 
      const highestLevelOrder = Math.max(...Object.keys(this.vc_selectedLocations).map(Number));
      this.oc_localCompany.locationId = this.vc_selectedLocations[highestLevelOrder] || null;
      } catch (error) {
        console.error(error);
      }
  }

  async fn_save() { 
    this.vc_isLoading = true;
    this.oc_localCompany.idCompany = this.vc_idCompany;
    console.log(this.oc_localCompany);
    (await this.oc_adminService.createlocal(this.vc_idCompany, this.oc_localCompany))
    .subscribe((res) => {
      this.vc_isLoading = false;
      if (this.vc_idLocal != -1) {
        this.oc_toastr.success(messagelanguage.message.LocalUpdated);
      } else {
        this.oc_toastr.success(messagelanguage.message.LocalCreated);
      }
      this.oc_dialogRef.close({
        accept: true,
        localCompany: this.oc_localCompany
      });
    },(error) => {
      this.vc_isLoading = false;
      if (error.status==400 && error.error?.error == "Name_exist") {
        this.oc_toastr.error(messagelanguage.message.NameExists);
      }
    });
  }

  async fn_loadDepartment() {
    let resourcesPath: string = 'users/resources';

    (await this.oc_patientService
      .getResources(resourcesPath))
      .subscribe((response: any) => {
        console.log(response);
        this.vc_resources.provinces = response.body;
      }, (error) => {
        console.log(error);
      });
  }

  async fn_updateProvinces() {
    let resourcesPath: string = 'department/' + this.oc_localCompany.department_id + '/provinces';

    (await this.oc_patientService
      .updateProvinces(resourcesPath))
      .subscribe(
      (response: any) => {
        console.log(response);
        this.vc_resources.provinces = response.body;
      }, (error) => {
        console.log(error);
      });
  }

  async fn_updateDistricts() {
    let resourcesPath: string = 'province/' + this.oc_localCompany.province_id + '/districts';

    (await this.oc_patientService
      .updateDistricts(resourcesPath))
      .subscribe(
        (response: any) => {
          console.log(response);
          this.vc_resources.districts = response.body;
      }, (error) => {
        console.log(error);
      });
  }

}
